import { render, staticRenderFns } from "./CustomerEditQuotations.vue?vue&type=template&id=0dbc783e"
import script from "./CustomerEditQuotations.vue?vue&type=script&lang=js"
export * from "./CustomerEditQuotations.vue?vue&type=script&lang=js"
import style0 from "./CustomerEditQuotations.vue?vue&type=style&index=0&id=0dbc783e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports